export default __webpack_public_path__ + "01f0e305480162a9b3fc5ed3c10b0932.png";